export default {
    "name": "SkuLookup",
    "kind": "HoudiniQuery",
    "hash": "bc89770b1f59bac28e67b710b690c5ff12d204be4295d73d789d20d1285b8404",

    "raw": `query SkuLookup($input: SkuLookupResolverInput!) {
  skuLookup(input: $input) {
    useInScanner
    relationshipType
    packageQuantity
    inventories {
      id
      storeId
      vehicleId
      skuNumber
      inventoryType {
        vehicle
        id
      }
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "skuLookup": {
                "type": "SkuLookup",
                "keyRaw": "skuLookup(input: $input)",

                "selection": {
                    "fields": {
                        "useInScanner": {
                            "type": "Boolean",
                            "keyRaw": "useInScanner",
                            "visible": true
                        },

                        "relationshipType": {
                            "type": "SkuLookupRelationshipTypeEnum",
                            "keyRaw": "relationshipType",
                            "visible": true
                        },

                        "packageQuantity": {
                            "type": "Int",
                            "keyRaw": "packageQuantity",
                            "visible": true
                        },

                        "inventories": {
                            "type": "Inventory",
                            "keyRaw": "inventories",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "storeId": {
                                        "type": "UInt",
                                        "keyRaw": "storeId",
                                        "visible": true
                                    },

                                    "vehicleId": {
                                        "type": "UInt",
                                        "keyRaw": "vehicleId",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "skuNumber": {
                                        "type": "UInt",
                                        "keyRaw": "skuNumber",
                                        "visible": true
                                    },

                                    "inventoryType": {
                                        "type": "InventoryType",
                                        "keyRaw": "inventoryType",

                                        "selection": {
                                            "fields": {
                                                "vehicle": {
                                                    "type": "Boolean",
                                                    "keyRaw": "vehicle",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "SkuLookupResolverInput"
        },

        "types": {
            "SkuLookupResolverInput": {
                "lookup": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=6b670c198ae422bb2945ea99b0caa89a333edb1ac9bf87ae2b63a6a5c2429ab2";